export default __webpack_public_path__ + "static/media/icon_mesh.6221a789.svg";